<template>
  <footer class="footer">
    <div class="page">
      <div class="row">
        <div class="col">
          <social-links/>
          <PrivacyPolicyButton/>
          <p>
            <a href="https://forms.gle/ESBTE7vxukyRmosTA" target="_blank">Arrepentimiento de compra</a>
          </p>
          <p>
            <a href="/user/removeAccount" target="_blank">Eliminar mi cuenta</a>
          </p>
          <img src="/images/LogoPlopPuerca.png" alt="Plop">
          <p>© {{ today.getFullYear() }} plop.com.ar</p>
        </div>
      </div>
    </div>

  </footer>
</template>
<script setup lang="ts">
import PrivacyPolicyButton from "~/components/buttons/PrivacyPolicyButton.vue";

const today = new Date();
</script>
